export const actionTypes = {
  REQUEST_START: 'GET_APP_IS_READY_CHECK.REQUEST_START',
  REQUEST_SUCCESS: 'GET_APP_IS_READY_CHECK.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'GET_APP_IS_READY_CHECK.REQUEST_FAILURE',
  RESET: 'GET_APP_IS_READY_CHECK.RESET',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
export function resetAppIsReady() {
  return {
    type: actionTypes.RESET,
  };
}
